import styled from 'styled-components';

import InputSimple, { phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Autocomplete from '@r1-frontend/ui-react/organisms/Forms/PersonForm/Autocomplete';

export const PersonForm = styled.div`
    display: grid;
    grid-template-columns: 1.1fr 1fr;
    flex-wrap: nowrap;
    width: 100%;
    gap: 12px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        grid-template-columns: 100%;
    }
`;

export const SAutocomplete = styled(Autocomplete)`
    width: 100%;
`;

export const Input = styled(InputSimple)`
    margin-bottom: 0;

    [class*="InputError"] {
        white-space: nowrap;
    }
`;

export const PhoneInput = phoneDecorator(Input);

export const PhoneField = styled(PhoneInput)`
    width: 100%;
`;

